import React from 'react';
import { ConnectedZoomContainer, HTMLZoomRenderer } from '@printu/viewport';
import { View } from '@react-spectrum/view';
export const Viewport = (props) => {
    const { scrollTarget } = props;
    const getScrollTarget = React.useCallback(() => scrollTarget(), [scrollTarget]);
    return (React.createElement(ConnectedZoomContainer, { renderer: HTMLZoomRenderer, className: "editor-content", contentClassName: "editor-virtual", scrollEventsTarget: getScrollTarget, viewportStateSelector: (state) => state.viewport },
        React.createElement(View, { width: "100%", height: "100%", backgroundColor: "gray-100", UNSAFE_style: { position: 'relative' } }, props.children)));
};
